import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from "@mui/material";


const EmailDialog = ({ open, onClose }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [emailData, setEmailData] = useState({
        recipient: "",
        recipientInput: "",
        subject: "",
        body: "",
    });
    const [mailList,setMailList] = useState([]);

    // ✅ メールデータ変更処理
    const handleChange = (e) => {
        setEmailData({ ...emailData, [e.target.name]: e.target.value });
    };

    // ✅ ファイル選択処理
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    useEffect(()=>{
        fetchData();
    },[]);

    const fetchData = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_DIR}/users/mail`, {
            method: "GET",
            headers: new Headers({ "Content-Type": "application/json" }),
            mode: "cors",
            credentials: "include",
          });
          if (!response.ok) {
            throw new Error("Failed to fetch user info");
          }
          const { data } = await response.json();
          setMailList(data);
        } catch (error) {
          console.error("ファイルの読み込みに失敗しました:", error);
        } finally {
          // setLoading(false);
        }
    };

    // ✅ メール送信処理
    const sendEmail = () => {
        // 📧 メールデータの作成
        const formData = new FormData();
        let recipient = null;
        if(emailData.recipientInput && emailData.recipientInput !== ""){
            recipient = emailData.recipientInput;
        }
        else{
            recipient = emailData.recipient;
        }

        if (!recipient || recipient === "") {
            alert("送信先のメールアドレスを入力してください。");
            return;
        }

        formData.append("recipient", recipient );
        formData.append("subject", emailData.subject);
        formData.append("body", emailData.body);
        
        console.log(emailData)
        // 選択されたファイルを添付
        if (selectedFile) {
            console.log(selectedFile);
            formData.append("file", selectedFile);
            formData.append("fileName", selectedFile.name);
        }

        // 📤 メール送信処理（サーバー側が必要
        postEmail(formData)

    };


    const postEmail = async(formData) =>{
        try {
            const response = await fetch(`${process.env.REACT_APP_API_DIR}/mail`, {
              method: "POST",
              mode: "cors",
            //   headers: new Headers({ "Content-Type": "application/json" }),
              credentials: "include",
              body: formData,
            });
            if (!response.ok) {
              throw new Error("Failed to fetch user info");
            }
            const data  = await response.json();
            console.log(data);
           if(data.isError){
                alert("メール送信に失敗しました。");
           }
           else{
            console.log(data.message)
                alert("メールを送信しました！");
                onClose();
           }
          } catch (error) {
            console.error("ファイルの読み込みに失敗しました:", error);
            alert("メール送信に失敗しました。");
          } finally {
            // setLoading(false);
          }
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>メール送信</DialogTitle>
            <DialogContent>
                {/* メールアドレス選択または入力 */}

                {(emailData.recipientInput === "") && (
                <TextField
                    select
                    fullWidth
                    label="送信先メールアドレスを選択"
                    name="recipient"
                    value={emailData.recipient}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                >
                    {mailList.map((value) => (
                        <MenuItem value={value.mail}>
                            {value.mail}({value.surname ?? ""}{value.name ?? ""})
                        </MenuItem>
                    ))}
                    <MenuItem value="">その他（手入力）</MenuItem>
                </TextField>
                )}

                {/* 直接入力用 */}
                {emailData.recipient === "" && (
                    <TextField
                        fullWidth
                        placeholder="送信先メールアドレスを入力"
                        name="recipientInput"
                        onChange={handleChange}
                        style={{ marginBottom: 10 }}
                    />
                )}

                {/* 件名 */}
                <TextField
                    fullWidth
                    label="件名"
                    name="subject"
                    value={emailData.subject}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                />

                {/* 本文 */}
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="本文"
                    name="body"
                    value={emailData.body}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                />

                {/* ファイル選択 */}
                <input type="file" onChange={handleFileChange} />
                
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">キャンセル</Button>
                <Button onClick={sendEmail} color="primary">送信</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmailDialog;
